import React, { useEffect } from 'react';
import { useAtom } from 'jotai';
import { CombinationText, ScanIconWrap, AICohortText } from './styled';
import { Tooltip } from 'antd';
import ErrorIcon from '@icons/noc/threshold-critical.svg';
import { getConfigList } from '@src/api/aiAlerts';
import { isConfigLoadingAtom, totalCombinationsAtom } from '@src/components/ai-cohorts/atoms';
import { getCardinalityText } from '@src/components/ai-cohorts/utils';
import { ApartmentOutlined } from '@ant-design/icons';

export default function DimensionScan() {
  const [isLoading, setLoading] = useAtom(isConfigLoadingAtom);
  const [totalCombinations, setTotalCombinations] = useAtom(totalCombinationsAtom);
  const isDataError = !isLoading && totalCombinations === 0;
  const displayConfigCombinations = () => {
    window.open(`${window.conviva.baseUrl}/dashboard/ai-cohorts`, '_blank', 'noopener,noreferrer');
  };
  const handleDisplayConfig = () => !isLoading && !isDataError && displayConfigCombinations();
  const tooltipMsg = isDataError && 'Error fetching from the system or traffic may be too low.';

  useEffect(() => {
    getConfigList().then((data) => {
      setLoading(false);
      setTotalCombinations(data?.data?.aiAlertsConfig?.[0]?.totalCombinations);
    });
  }, [setLoading, setTotalCombinations]);

  return (
    <Tooltip title={tooltipMsg}>
      <div>
        <CombinationText
          isLoading={isLoading}
          onClick={handleDisplayConfig}
          isError={isDataError}
          isLink
          style={{ display: 'inline-block' }}
        >
          {
            <ScanIconWrap>
              <ApartmentOutlined />
            </ScanIconWrap>
          }
          {isDataError && <ErrorIcon />}
          {getCardinalityText(totalCombinations, 2, isLoading, isDataError)}
        </CombinationText>
      </div>
      <AICohortText>(AI Cohorts)</AICohortText>
    </Tooltip>
  );
}
